(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('InfectionPrimaryAccessSearch', InfectionPrimaryAccessSearch);

    InfectionPrimaryAccessSearch.$inject = ['$resource'];

    function InfectionPrimaryAccessSearch($resource) {
        var resourceUrl =  'api/_search/infection-primary-accesses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
